export const formataNumeroComPontos = (numero) => {
  try {
    var numeroFormatado = String(numero).replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g,'$1.');
    return numeroFormatado;
  } catch (error) {
    console.error(error);
  }
  
}

export const formataDataUtcToDDMMYYYY = (stringdata) =>{
  var date = new Date(stringdata)
  var dd = date.getDate(); 
  var mm = date.getMonth()+1;
  var yyyy = date.getFullYear(); 
  if(dd<10){dd='0'+dd};
  if(mm<10){mm='0'+mm};
  var stringDataFormatada = dd+'/'+mm+'/'+yyyy;
  return stringDataFormatada;
}